import vm from '@/main'
import axios from 'axios'
import dayjs from 'dayjs'
import {
  getKnowledgeList,
  uploadKnowledge,
  remove,
  download,
  syncCloud,
  downloadHD
} from '@/api/cloudKnowledge'
import { isImage, blobToBase64, transferFileSize, getFileIcon } from '@/utils/extend'

const CloudKnowledge = {
  namespaced: true,
  state: {
    // 空状态loading
    dataLoading: true,
    // 存储信息
    storage_info: {},
    // 文件列表
    uploadedFileList: [],
    uploadingFileList: [],
    // 分页
    total: 0,
    pageSize: 25,
    page: 1,
    loading: false
  },
  mutations: {
    SET_STORAGE_INFO: (state, val) => {
      state.storage_info = val
    },
    SET_UPLOADING_FILELIST: (state, val) => {
      state.uploadingFileList = val
    },
    SET_UPLOADED_FILELIST: (state, val) => {
      state.uploadedFileList = val
    },
    SET_FILE_UPLOADED: (state, payload) => {
      for (const k in payload.val) {
        state.uploadedFileList[payload.index][k] = payload.val[k]
      }
    },
    SET_FILE: (state, payload) => {
      const index = state.uploadingFileList.findIndex(item => item.uid === payload.item.uid)
      if (index === -1) return
      for (const k in payload.val) {
        state.uploadingFileList[index][k] = payload.val[k]
      }
    },
    TRANS_FILE: (state, payload) => {
      const index = state.uploadingFileList.findIndex(item => item.id === payload.item.id)
      state.uploadingFileList.splice(index, 1)
      state.uploadedFileList.unshift(payload.item)
      if (!payload.noMore) {
        state.uploadedFileList.pop()
      } else {
        state.total += 1
        console.log(state.total, state.uploadedFileList.length)
      }
    },
    ADD_FILE: (state, val) => {
      state.uploadingFileList.unshift(val)
    },
    SET_TOTAL: (state, val) => {
      state.total = val
    },
    RESET_UPLOADED_DATA: state => {
      state.uploadedFileList = []
      state.total = 0
      state.pageSize = 25
      state.page = 1
      state.loading = false
    },
    RESET_DATA: state => {
      state.dataLoading = true
      state.uploadingFileList = []
      state.uploadedFileList = []
      state.total = 0
      state.pageSize = 25
      state.page = 1
      state.loading = false
    }
  },
  getters: {
    isUploading(state) {
      return state.fileList.filter(item => !item.finish && !item.error).length
    },
    fileList(state) {
      if (!state.uploadingFileList.length && !state.uploadedFileList.length) {
        return null
      }
      return state.uploadingFileList.concat(state.uploadedFileList)
    },
    noMore(state) {
      console.log(state.uploadedFileList.length, state.total)
      return !!(!state.total || state.uploadedFileList.length === state.total)
    },
    disabled(state) {
      return !!(state.loading || state.noMore)
    }
  },
  actions: {
    // 删除更新某页数据
    refreshKnowledgeList({ commit, state }) {
      const { page, pageSize } = state
      return new Promise((resolve, reject) => {
        const data = { page, page_size: pageSize }
        getKnowledgeList(data)
          .then(res => {
            if (res.status === 0) {
              const { storage_info, files, total } = res.result || {
                files: [],
                total: 0
              }
              const transFiles = files.map(item => {
                const isimage = isImage(item.type)
                return {
                  ...item,
                  fileType: 'uploaded',
                  isCloud: true,
                  length: item.content_length || 0,
                  isimage,
                  uid: item.id,
                  wholeName: item.name + '.' + item.type,
                  imageurl: isimage ? item.url : '',
                  icon: isimage ? item.url : getFileIcon(item.type),
                  transferFileSize: transferFileSize(item.size * 1024),
                  download: false,
                  downloadPercent: 0,
                  xhr: null,
                  finish: true
                }
              })
              const start = (page - 1) * pageSize
              state.uploadedFileList.splice(start, pageSize, ...transFiles)
              state.total = total
              state.loading = false
              commit('SET_STORAGE_INFO', { ...storage_info })
              resolve(res)
            } else {
              reject()
            }
          })
          .catch(() => {
            reject()
          })
      })
    },
    // 获取已上传文件列表
    getKnowledgeList({ commit, state }) {
      return new Promise((resolve, reject) => {
        const data = { page: state.page, page_size: state.pageSize }
        getKnowledgeList(data)
          .then(res => {
            if (res.status === 0) {
              const { storage_info, files, total } = res.result || {
                files: [],
                total: 0
              }
              const transFiles = files.map(item => {
                const isimage = isImage(item.type)
                return {
                  ...item,
                  fileType: 'uploaded',
                  isCloud: true,
                  length: item.content_length || 0,
                  isimage,
                  uid: item.id,
                  wholeName: item.name + '.' + item.type,
                  imageurl: isimage ? item.url : '',
                  icon: isimage ? item.url : getFileIcon(item.type),
                  transferFileSize: transferFileSize(item.size * 1024),
                  download: false,
                  downloadPercent: 0,
                  xhr: null,
                  finish: true
                }
              })
              console.log('transFiles', transFiles.length)
              const fileList = [...state.uploadedFileList, ...transFiles]
              console.log(fileList.length)
              state.total = total
              state.loading = false
              commit('SET_UPLOADED_FILELIST', fileList)
              commit('SET_STORAGE_INFO', { ...storage_info })
              resolve(res)
            } else {
              reject()
            }
          })
          .catch(() => {
            reject()
          })
          .finally(() => {
            state.dataLoading = false
          })
      })
    },
    learMore({ state, getters, dispatch }) {
      if (state.total && !getters.noMore) {
        state.loading = true
        state.page++
        dispatch('getKnowledgeList')
      }
    },
    // 上传
    async beforeUpload({ commit, getters }, file) {
      const cancelTokenSource = axios.CancelToken.source()
      const isimage = isImage(file.name)
      let imageurl = ''
      if (isimage) {
        imageurl = await blobToBase64(file)
      }
      return new Promise((resolve, reject) => {
        console.log(file)
        const name = file.name.substring(0, file.name.lastIndexOf('.'))
        const type = file.name.substring(file.name.lastIndexOf('.') + 1)
        const isLt20M = file.size / 1024 / 1024 <= 20
        if (!isLt20M) {
          vm.$message.success('上传文件大小不能超过 20MB!')
          reject(false)
        } else {
          const item = {
            fileType: 'uploading',
            isCloud: true,
            length: 0,
            id: file.uid,
            uid: file.uid,
            wholeName: file.name,
            name,
            size: file.size,
            transferFileSize: transferFileSize(file.size),
            url: '',
            isimage,
            imageurl,
            icon: isimage ? imageurl : getFileIcon(type),
            type,
            percent: 0,
            upload_date: dayjs(new Date()).format('YYYY-MM-DD'),
            finish: false,
            error: false,
            download: false,
            downloadPercent: 0,
            retryFile: file,
            cancelTokenSource,
            xhr: null
          }
          commit('ADD_FILE', item)
          resolve(true)
        }
      })
    },
    uploadKnowledge({ state, getters, commit, dispatch }, file) {
      const item = state.uploadingFileList.find(item => item.uid === file.uid)
      const { isimage, imageurl, type, cancelTokenSource } = item
      return new Promise((resolve, reject) => {
        uploadKnowledge({ file, item, cancelTokenSource })
          .then(res => {
            console.log(res)
            if (res.status === 0) {
              if (res.result.file_url) {
                commit('SET_FILE', {
                  item,
                  val: {
                    id: res.result.id,
                    uid: res.result.id,
                    name: res.result.file_name,
                    type: res.result.file_type,
                    url: res.result.file_url,
                    imageurl: isimage ? res.result.file_url : imageurl,
                    icon: isimage ? res.result.file_url : getFileIcon(type)
                  }
                })
              }
              commit('SET_FILE', { item, val: { finish: true } })
              // commit('TRANS_FILE', { item, noMore: getters.noMore })
              commit('RESET_DATA')
              dispatch('getKnowledgeList')
              resolve(res)
            } else if (res.status === 1) {
              resolve(res)
            } else {
              // commit('SET_FILE', { index, val: { error: true } })
              const fileList = state.uploadingFileList.filter(v => v.uid !== item.uid)
              commit('SET_UPLOADING_FILELIST', fileList)
              vm.$message.success('上传失败，请重新上传')
              reject()
            }
          })
          .catch(err => {
            console.log(err)
            // commit('SET_FILE_LIst', { index, val: { error: true } })
            const fileList = state.uploadingFileList.filter(v => v.uid !== item.uid)
            commit('SET_UPLOADING_FILELIST', fileList)
            reject(err)
          })
      })
    },
    // 删除
    remove({ state, commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        remove({ file_id: payload?.file?.id })
          .then(res => {
            if (res.status === 0) {
              resolve()
              const fileList = state.uploadedFileList.filter(item => item.id !== payload?.file?.id)
              console.log(fileList.length, payload)
              if (payload.file.fileType === 'uploading') {
                commit('SET_UPLOADING_FILELIST', fileList)
              } else if (payload.file.fileType === 'uploaded') {
                commit('SET_UPLOADED_FILELIST', fileList)
                dispatch('refreshKnowledgeList')
                // commit('SET_TOTAL', fileList.length)
              }
              commit('SET_STORAGE_INFO', { ...res.result })

              vm.$message.success('删除成功')
            } else {
              reject()
            }
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    // 下载
    download({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        download({ file_id: payload?.file?.id })
          .then(res => {
            if (res.status === 0) {
              resolve()
              vm.$message('下载成功')
            } else {
              reject()
            }
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    // 同步云盘
    syncCloud({ state, commit, rootGetters }, payload) {
      const isSyncStorage = rootGetters['Home/isSyncStorage']
      if (!isSyncStorage) return
      return new Promise((resolve, reject) => {
        syncCloud(payload)
          .then(res => {
            if (res.status === 0) {
              resolve(res)
              // Vue.prototype.$message('同步云盘成功')
            } else if (res.status === 1) {
              resolve(res)
            } else {
              reject()
            }
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    // 下载高清大图
    downloadHD({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        // 判断是否可以中断
        let signal = ''
        if (payload.signal) {
          signal = payload.signal
          delete payload.signal
        }
        const arr = [{ ...payload }]
        signal && arr.push(signal)
        downloadHD(...arr)
          .then(res => {
            if (res.status === 0) {
              resolve(res)
            } else {
              reject()
            }
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    handleRetry({ state, commit, dispatch }, file) {
      const index = state.fileList.findIndex(item => item.uid === file.uid)
      commit('SET_FILE', { index, val: { error: false, finish: false } })
      dispatch('uploadFile', file.retryFile)
    },
    // 停止上传
    stopUpload({ state, commit }, payload) {
      payload.file?.cancelTokenSource?.cancel()
      const fileList = state.uploadingFileList.filter(item => item.uid !== payload?.file?.uid)
      commit('SET_UPLOADING_FILELIST', fileList)
    },
    // 停止下载
    stopDownload({ state, commit }, payload) {
      payload.file?.xhr?.abort()
      const index = state.uploadedFileList.findIndex(item => item.id === payload?.file?.id)
      commit('SET_FILE_UPLOADED', {
        index,
        val: {
          xhr: null,
          download: false,
          downloadPercent: 0
        }
      })
    }
  }
}

export default CloudKnowledge
